import { TiktokAdsConnectionSchema } from "@redotech/redo-model/integration/tiktok-ads/tiktok-ads-definition";
import * as z from "zod";

export const getTiktokAdsIntegration = {
  name: "getTiktokAdsIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    advertiserId: z.string().optional(),
    needsReauth: z.boolean(),
    connections: z.array(TiktokAdsConnectionSchema),
  }),
};
